export enum OTA_STATUS {
    IDLE = 'idle',
    STARTED = 'started',
    CONNECTED = 'connected',
    DOWNLOADING = 'downloading',
    INSPECTING = 'inspecting',
    VERIFYING = 'verifying',
    DECRYPTING = 'decrypting',
    UPDATING = 'updating',
    COMPLETE = 'complete',
    FAILED = 'failed',
    CANCELLED = 'cancelled',
    UPDATED = 'updated'
}

export enum OTA_ERROR_CODE {
    BATTERY = 'battery',
    BUSY = 'busy',
    GENERAL = 'general',
    REQUEST = 'request',
    CONNECTION = 'connection',
    DOWNLOAD = 'download',
    VERSION = 'version',
    VALIDATION = 'validation',
    ROLLBACK = 'rollback'
}

export interface OTAUpdatePayload {
    type: 'error' | 'progress' | 'version'
    data: {
        state?: OTA_STATUS
        value?: number
        code?: OTA_ERROR_CODE
    }
}
